import React, { useRef, useEffect } from 'react';
import './PlacesCarousel.css';
import { Typography } from '@material-ui/core';

const PlacesCarousel = ({ places, activePlaceId, onSelectPlace }) => {
  const cardRefs = useRef({});

  useEffect(() => {
    if (activePlaceId && cardRefs.current[activePlaceId]) {
      cardRefs.current[activePlaceId].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }, [activePlaceId]);

  return (
    <div className="places-carousel-container">
      <div className="places-carousel-scroll">
        {places.map((place) => (
          <div
            className={
              'places-carousel-card' +
              (place.pageid === activePlaceId ? ' places-carousel-card-active' : '')
            }
            key={place.pageid}
            ref={el => (cardRefs.current[place.pageid] = el)}
            onClick={() => onSelectPlace && onSelectPlace(place.pageid)}
          >
            <div className="places-carousel-row">
              {place.thumbnail?.source ? (
                <img
                  className="places-carousel-thumb"
                  src={place.thumbnail.source}
                  alt={place.title}
                  onClick={e => {
                    e.stopPropagation();
                    window.open(place.fullurl, '_blank');
                  }}
                />
              ) : (
                <div className="places-carousel-thumb-placeholder" />
              )}
              <Typography className="places-carousel-title" variant="h6">
                {place.title}
              </Typography>
            </div>
            <Typography className="places-carousel-description" variant="body2">
              {place.wikipediaContent || 'Loading description...'}
            </Typography>
            <a
              href={place.fullurl}
              target="_blank"
              rel="noopener noreferrer"
              className="places-carousel-link"
              onClick={e => e.stopPropagation()}
            >
              Wikipedia
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlacesCarousel; 